import React from 'react';
import { getEditorPreloader } from '@confluence-classic/confluence-fabric-editor/src/lib/index.ts';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { GoToHomeLoader } from '@confluence/home-redirects/entry-points/GoToHome.ts';
import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';

export const HomeRoute = () => <GoToHomeLoader />;

HomeRoute.NAVIGATION_PARAMS = ({ name }: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'homeScreen',
			attributes: {
				navdexPointType: START_TOUCH,
			},
		},
		pageState: { routeName: name },
	},
	MainLayout: {
		navView: PRODUCT_HOME_ID,
		editorPreloader: getEditorPreloader,
	},
});
